import { FC, useState } from 'react';
import { Image, Card, Accordion, AccordionItem } from '@heroui/react';
import { LuChevronDown, LuShip } from 'react-icons/lu';
import { useAppSelector } from '../../../../core/rootHooks';
import { RootState } from '../../../../core/store';
import { selectVesselImageData } from '../../../../user-management/appSelectors';
import VesselImageCopyright from '../../../../shared/components/image-copyrights/VesselImageCopyright';
import { VesselInfo } from './VesselInfo';
import { selectSubscribedMsiVesselByImoNumber } from '../../../../shared/sharedSelectors';
import { IVesselFormData } from '../../../../shared/sharedTypes';

export interface IVesselPopupSummaryProps {
	info: IVesselFormData;
	eta?: Date;
	destination?: string;
}

const VesselPopupSummary: FC<IVesselPopupSummaryProps> = (props: IVesselPopupSummaryProps) => {
	const [isHovered, setIsHovered] = useState<boolean>(false);

	const vesselImageData = useAppSelector((state: RootState) =>
		selectVesselImageData(state, props.info.imoNumber || 0),
	);

	const vesselData = useAppSelector((state: RootState) =>
		selectSubscribedMsiVesselByImoNumber(state, props.info.imoNumber || 0),
	);

	return (
		<Card
			className={`fixed rounded-none z-20 p-1 -ml-2 ${isHovered ? 'opacity-100' : 'opacity-85'} transition-all duration-300 ease-in-out`}
			style={{ width: isHovered ? 280 : 200 }}
		>
			<Accordion
				selectionMode="single"
				className="px-0"
				selectedKeys={isHovered ? ['1'] : ['']}
				fullWidth
				hideIndicator
				isCompact
			>
				<AccordionItem
					key={'1'}
					aria-label={props.info.name || 'Vessel'}
					classNames={{
						startContent: 'w-full',
						trigger: 'p-0 m-0',
					}}
					onMouseEnter={() => setIsHovered(true)}
					onMouseLeave={() => setIsHovered(false)}
					startContent={
						<div
							className="relative transition-all duration-500 ease-in-out flex items-center justify-center"
							style={{ height: isHovered ? 192 : 104 }}
						>
							{((vesselImageData?.name === 'no_vessel_image' || !vesselImageData) && (
								<div className="w-full h-full flex items-center justify-center">
									<LuShip className="w-full h-full " color="#3F4B4B" strokeWidth={0.5} />
								</div>
							)) || (
								<Image
									src={vesselImageData?.imageData}
									alt="Ship Image"
									style={{ objectFit: 'fill' }}
									width={isHovered ? 288 : 200}
									height={isHovered ? 192 : 104}
									className="rounded transition-all duration-300 ease-in-out cursor-default"
								/>
							)}
							{!isHovered && (
								<LuChevronDown color="black" size={15} className="bg-white rounded absolute bottom-1 right-1 z-20" />
							)}
						</div>
					}
				>
					<div className="flex flex-col text-xs space-y-1 text-center">
						<VesselImageCopyright vesselName={vesselImageData?.name} sourceUrl={vesselImageData?.sourceUrl} />
					</div>

					<VesselInfo vesselData={vesselData} />
				</AccordionItem>
			</Accordion>
		</Card>
	);
};

export default VesselPopupSummary;
